<template>
  <div class="page-container">
    <h2 class="page-title">商品管理</h2>

  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    openAddDialog() {
      // 打开新增弹窗逻辑
    }
  }
}
</script>

<style scoped>
.page-title {
  margin-bottom: 20px;
  color: #333;
}

.search-bar {
  margin-bottom: 20px;
}
</style>